/* File: src/components/explanations/shredsListExplanation.ts */
export const shredsListExplanation = `
<div class="text-gray-300 text-lg mb-4">

    <hr class="border-b-1 border-gray-600 my-2">
  
    <h2 class="text-blue-400 text-xl font-bold mb-2">1. What is the Shred Plan?</h2>
    <p class="text-gray-200 text-base mb-4">
      These are the final specifications for Shred, generated by AI. This document is here to confirm that the AI has accurately understood your requirements.<br/>
      Please review it carefully, as it represents the final step before code generation which will consume credits.
    </p>
    <h2 class="text-green-400 text-xl font-bold mb-2">2. How to Modify It?</h2>
    <p class="text-gray-200 text-base mb-4">
      Simply list your modifications in the field at the bottom of this page.<br/>
      Describe your changes as you would explain them to a developer.
    </p>
    <span class="chip">TIP</span> : Use clear and well-defined bullet points to detail your modifications.
</div>
`;
